<template>

    <div>

        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Feridas"
        >

            <rkm-area title="Cadastrar ferida" type="fieldset" no-margin-top>

                <rkm-form
                    v-if="!readonly"
                    ref="RkmForm"
                >
                    <rkm-row>

                        <rkm-col cols="4">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Selecione o tipo da ferida conforme catálogo padronizado (ex.: úlcera venosa, pé diabético).'
                                }"
                            />

                            <rkm-form-select
                                :options="data.form.tipos"
                                :validations="validations.tipo"
                                label="Tipo da ferida"
                                v-model="model.tipoId"
                                value-field="id"
                                show-default-option
                                text-field="nome"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="4">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe a região do corpo onde a ferida está localizada.'
                                }"
                            />

                            <rkm-form-select
                                :options="data.form.locaisAnatomico"
                                :validations="validations.tipo"
                                label="Local anatômico"
                                v-model="model.localAnatomicoId"
                                value-field="id"
                                show-default-option
                                text-field="descricao"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="4">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe a região do corpo onde a ferida está localizada.'
                                }"
                            />

                            <rkm-form-select
                                :options="data.form.locaisAnatomicoRegiao.filter(r => r.localAnatomicoId === model.localAnatomicoId)"
                                :validations="validations.tipo"
                                label="Local anatômico região"
                                v-model="model.localAnatomicoRegiaoId"
                                value-field="id"
                                show-default-option
                                text-field="descricao"
                                :disabled="!model.localAnatomicoId || visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe a data em que a ferida foi identificada ou iniciou o tratamento.'
                                }"
                            />

                            <rkm-form-date-picker
                                :min-date="data.additionals.paciente.dataNascimento"
                                :validations="validations.data"
                                label="Data de início"
                                v-model="model.data"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Selecione o volume de secreção presente na ferida'
                                }"
                            />

                            <rkm-form-select
                                :options="data.form.exsudatos"
                                :validations="validations.tipo"
                                label="Exsudato"
                                v-model="model.exsudatoId"
                                value-field="id"
                                show-default-option
                                text-field="descricao"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe se há tecido necrótico visível na ferida.'
                                }"
                            />

                            <rkm-form-select
                                :options="data.form.necroses"
                                :validations="validations.tipo"
                                label="Necrose"
                                v-model="model.necroseId"
                                value-field="id"
                                show-default-option
                                text-field="descricao"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Status atual da ferida: ativa em tratamento ou cicatrizada (finalizada)'
                                }"
                            />

                            <rkm-form-radio-group
                                v-model="model.cicatrizada"
                                label="Status"
                                :disabled="visualizarModo"
                            >
                                <rkm-form-radio :value="false">Ativa</rkm-form-radio>
                                <rkm-form-radio :value="true">Cicatrizada</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe o comprimento da ferida em centímetros (ponta a ponta no maior eixo).'
                                }"
                            />

                            <rkm-form-input
                                :validations="validations.comprimento"
                                append="cm"
                                label="Comprimento"
                                placeholder="0.0"
                                type="number"
                                step="0.1"
                                v-model="model.comprimento"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe a largura da ferida em centímetros (perpendicular ao comprimento).'
                                }"
                            />

                            <rkm-form-input
                                :validations="validations.largura"
                                append="cm"
                                label="Largura"
                                placeholder="0.0"
                                type="number"
                                step="0.1"
                                v-model="model.largura"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Informe a profundidade da ferida em centímetros (quando aplicável).'
                                }"
                            />

                            <rkm-form-input
                                :validations="validations.profundidade"
                                append="cm"
                                label="Profundidade"
                                placeholder="0.0"
                                type="number"
                                step="0.1"
                                v-model="model.profundidade"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>

                        <rkm-col cols="3">

                            <rkm-icon
                                icon="info"
                                color="secondary"
                                class="infor d-flex pa-2 float-right"
                                small
                                v-rkm-popover.hover.left="{
                                    html:true,
                                    content: 'Avalie a dor do paciente usando escala numérica de 0 a 10.'
                                }"
                            />

                            <rkm-form-input
                                :validations="validations.dor"
                                label="Dor"
                                placeholder="00"
                                v-mask="masks.dor"
                                v-model="model.dor"
                                :disabled="visualizarModo"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">

                            <rkm-area title="Imagens" no-margin-top>

                                <rkm-row>

                                    <rkm-col class="flex-grow-1">

                                        <rkm-icon
                                            icon="info"
                                            color="secondary"
                                            class="infor d-flex pa-2 float-right"
                                            small
                                            v-rkm-popover.hover.left="{
                                                html:true,
                                                content: 'Anexe fotos para registrar a evolução visual da ferida. Use iluminação adequada.'
                                            }"
                                        />

                                        <rkm-form-file
                                            label="Cadastrar imagens"
                                            v-model="model.image"
                                            type="file"
                                            placeholder="SELECIONE AS IMAGENS"
                                            browse-text="Selecionar"
                                            ref="file-input"
                                            multiple
                                            @change="validarAnexos"
                                            :disabled="visualizarModo"
                                        >
                                            Pesquisar
                                        </rkm-form-file>
                                    </rkm-col>
                                </rkm-row>
                            </rkm-area>
                        </rkm-col>
                    </rkm-row>

                    <rkm-area title="Imagens salvas" type="fieldset">

                        <rkm-table
                            :fields="fieldsImage"
                            :items="model.images || []"
                            hide-filters
                            hide-pagination
                        >

                            <template v-slot:cell(arquivo)="{ item }">
                                <img
                                    :src="item.arquivo"
                                    width="60"
                                    alt="Arquivo"
                                />
                            </template>

                            <template v-slot:cell(actions)="{item}">

                                <rkm-button
                                    @click="destroyImage(item)"
                                    color="danger"
                                    small
                                    title="Excluir"
                                    :disabled="visualizarModo"
                                >
                                    <rkm-icon icon="trash" />
                                </rkm-button>
                            </template>
                        </rkm-table>
                    </rkm-area>

                    <rkm-row>
                        <rkm-col cols="12">

                            <BoxProcedimento :data="{paciente: data.additionals.paciente, soap: data.soap, ...model, visualizarModo}" :ferida-model="model" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <rkm-button
                                :label="false"
                                @click="store"
                                color="primary"
                                :disabled="visualizarModo"
                            >
                                {{ model.id ? 'Alterar' : 'Incluir' }}
                            </rkm-button>

                            <rkm-button
                                :label="false"
                                @click="resetForm"
                            >
                                Limpar
                            </rkm-button>
                        </rkm-col>
                    </rkm-row>
                </rkm-form>
            </rkm-area>

            <rkm-area title="Feridas cadastradas" type="fieldset">

                <rkm-table
                    :fields="fields"
                    :items="items"
                    hide-filters
                    hide-pagination
                >

                    <template v-slot:cell(arquivo)="{ item }">
                        <div style="display: flex; gap: 6px; flex-wrap: wrap;">
                            <img
                                v-for="(img, index) in item.images"
                                :key="index"
                                :src="img.arquivo"
                                width="40"
                                height="40"
                                style="object-fit: cover; border-radius: 6px;"
                                alt="Imagem da ferida"
                            />
                        </div>
                    </template>

                    <template v-slot:cell(cicatrizada)="{item}">

                        {{ item.cicatrizada ? 'Cicatrizada' : 'Ativa' }}
                    </template>

                    <template v-slot:cell(actions)="{item}">

                        <rkm-button
                            @click="visualizar(item, true)"
                            color="primary"
                            small
                            title="Visualizar"
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>

                        <rkm-button
                            @click="edit(item)"
                            color="primary"
                            small
                            title="Editar"
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            @click="destroy(item)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-area>
            <template v-slot:footer="{cancel}">
                <rkm-button @click="cancel">
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalProcedimento
            :data="{paciente: data.additionals.paciente, ...model, soap: data.soap }"
            :ferida-model="model"
            ref="ModalProcedimento"
        />
    </div>
</template>

<script>
// Components.
import BoxProcedimento from './components/procedimento/Index'
import ModalProcedimento from './components/procedimento/Modal'

// Enums.
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        BoxProcedimento,
        ModalProcedimento
    },
    computed: {
        items() {
            return this.data.model.feridas || []
        },
        soapIdRef() {
            return this.data.additionals.soapIdRef
        },
        validations() {

            return {
                data: {required: true},
                tipo: {required: true},
                comprimento: {
                    min_value: 0,
                    max_value: 100,
                },
                largura: {
                    min_value: 0,
                    max_value: 100,
                },
                profundidade: {
                    min_value: 0,
                    max_value: 10,
                },
                dor: {
                    min_value: 0,
                    max_value: 10,
                },
            }
        },
        fields() {

            const fields = [
                {key: 'data', label: 'Data', sortable: true},
                {key: 'tipoDescricao', label: 'Tipo de ferida', sortable: true},
                {key: 'localAnatomicoDescricao', label: 'Local anatômico', sortable: true},
                {key: 'localAnatomicoRegiaoDescricao', label: 'Local Anatômico Região', sortable: true},
                {key: 'arquivo', label: 'Imagens', sortable: true},
                {key: 'cicatrizada', label: 'Status', sortable: true},
            ]

            if (!this.readonly) {

                fields.push({class: 'col-min text-center', key: 'actions', label: 'Ações'})
            }

            return fields
        },
        fieldsImage() {

            const fields = [
                {key: 'arquivo', label: 'Imagem', class: 'col-10', sortable: true},
                {key: 'actions', label: 'Ações', class: 'col-min text-center', sortable: true},
            ]

            return fields
        }
    },
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
            atendimento: this.getConectaSusRepository('ambulatorio.atendimentoEnfermagem'),
            ferida: this.getConectaSusRepository('cadastro.ferida'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    mounted() {
        this.syncProcedimentosFeridas()
    },
    watch: {
        'model.tipoId'(newVal) {

            if (this.isPopulating) {
                return
            }

            this.model.localAnatomicoId = null
            this.model.localAnatomicoRegiaoId = null

            if (!newVal) {
                this.model.procedimentos = []
                return
            }

            this.model.procedimentos = []

            this.setLoading()
            this.repositories.ferida.edit(newVal)
                .then(response => {
                    const procedimentos = response.data.model.procedimentos || []
                    const ids = procedimentos.map(p => p.id)

                    if (ids.length === 0) {
                        this.model.procedimentos = []
                        return
                    }

                    this.validarProcedimentosCboFerida(procedimentos, true)
                        .then(procedimentosFiltrados => {
                            this.model.procedimentos = procedimentosFiltrados.map(p => ({
                                procedimento: {
                                    id: p.id,
                                    codigo: p.codigo,
                                    nome: p.nome
                                },
                                cid: p.cid ? p.cid : (p.cid_id ? {
                                    id: p.cid_id,
                                    codigo: p.cid && p.cid.codigo,
                                    nome: p.cid && p.cid.nome
                                } : null),
                                automatico: true,
                                quantidade: p.quantidade != null ? p.quantidade : null
                            }))
                        })
                        .catch(this.handleError)
                })
                .catch(this.handleError)
                .finally(this.unsetLoading)
        },

        'model.localAnatomicoId'() {

            if (this.isPopulating) {
                return
            }

            this.model.localAnatomicoRegiaoId = null
        },

        'model.procedimentos': {
            handler() {
                this.syncProcedimentosFeridas()
            },
            deep: true
        },
    },
    data: () => ({
        enums: {unidadeMedida},
        visualizarModo: false,
        isPopulating: false,
        masks: {
            largura: '###',
            comprimento: '###',
            profundidade: '##',
            dor: '##',
        },
        model: {
            id: null,
            data: null,
            tipoId: null,
            localAnatomicoId: null,
            localAnatomicoRegiaoId: null,
            exsudatoId: null,
            necroseId: null,
            dor: null,
            image: null,
            cicatrizada: false,
            comprimento: null,
            largura: null,
            profundidade: null,
            procedimentos: []
        },
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        normalizeDecimalValue(value) {

            const normalized = String(value).replace(',', '.')
            const parsed = parseFloat(normalized)

            return Number.isNaN(parsed) ? null : parsed
        },
        open() {
            this.mergeProcedimentosFromPlano()
            this.resetForm()
            this.$nextTick(() => {
                this.$refs.RkmModal.show()
            })
        },
        mergeProcedimentosFromPlano() {
            const procedimentosPlano = (this.data.soap && this.data.soap.plano && this.data.soap.plano.procedimentosFeridas)
                ? this.data.soap.plano.procedimentosFeridas
                : (this.data.soap && this.data.soap.procedimentosFeridas ? this.data.soap.procedimentosFeridas : [])

            if (!this.data.model.feridas) {
                return
            }

            this.data.model.feridas.forEach(ferida => {
                if (ferida.procedimentos) {
                    ferida.procedimentos = []
                }
            })

            if (!procedimentosPlano.length) {
                return
            }

            procedimentosPlano.forEach(p => {
                const feridaId = p.ferida_id || p.atendimentoSoapFeridaId || p.feridaId

                if (feridaId) {
                    const ferida = this.data.model.feridas.find(f => f.id == feridaId)

                    if (ferida) {
                        if (!ferida.procedimentos) {
                            this.$set(ferida, 'procedimentos', [])
                        }

                        const procIndex = ferida.procedimentos.findIndex(fp => fp.id == p.id || (fp.procedimento && fp.procedimento.id == p.procedimento.id))

                        const normalizedProcedimento = {
                            ...p,
                            cid: p.cid ? {
                                id: p.cid.id,
                                codigo: p.cid.codigo,
                                nome: p.cid.nome
                            } : (p.cid_id ? { id: p.cid_id } : null),
                            quantidade: p.quantidade
                        }

                        if (procIndex !== -1) {
                            this.$set(ferida.procedimentos, procIndex, {
                                ...ferida.procedimentos[procIndex],
                                ...normalizedProcedimento
                            })
                        } else {
                            ferida.procedimentos.push(normalizedProcedimento)
                        }
                    }
                }
            })
            const procedimentosVisualizacao = this.data.soap.procedimentosVisualizacao ? this.data.soap.procedimentosVisualizacao : []
            procedimentosVisualizacao.forEach(p => {
                const feridaId = p.ferida_id || p.atendimentoSoapFeridaId || p.feridaId

                if (feridaId) {
                    const ferida = this.data.model.feridas.find(f => f.id == feridaId)
                    if (ferida) {
                        if (!ferida.procedimentos) {
                            this.$set(ferida, 'procedimentos', [])
                        }
                        const procIndex = ferida.procedimentos.findIndex(fp => fp.id == p.id || (fp.procedimento && fp.procedimento.id == p.procedimento.id))
                        const normalizedProcedimento = {
                            ...p,
                            cid: p.cid ? {
                                id: p.cid.id,
                                codigo: p.cid.codigo,
                                nome: p.cid.nome
                            } : (p.cid_id ? { id: p.cid_id } : null),
                            quantidade: p.quantidade
                        }
                        if (procIndex !== -1) {
                            this.$set(ferida.procedimentos, procIndex, {
                                ...ferida.procedimentos[procIndex],
                                ...normalizedProcedimento
                            })
                        } else {
                            ferida.procedimentos.push(normalizedProcedimento)
                        }
                    }
                }
            })

            this.syncProcedimentosFeridas()
        },
        syncProcedimentosFeridas() {

            if (!this.data.soap) {
                return
            }

            const allFeridas = [...this.data.model.feridas]
            const allProcedimentos = []
            const localProcedimentos = []
            allFeridas.forEach(f => {
                if (f.procedimentos){
                    f.procedimentos.forEach(p => {
                        if(f.soapId == this.data.additionals.soapIdRef) {
                            allProcedimentos.push({
                                ...p,
                                ferida_id: f.id, exibirFlag: (f.soapId == this.data.additionals.soapIdRef)
                            })
                        } else {
                            localProcedimentos.push({
                                ...p,
                                ferida_id: f.id, exibirFlag: (f.soapId == this.data.additionals.soapIdRef)
                            })

                        }
                    })
                }
            })

            if (this.data.soap.plano) {
                this.$set(this.data.soap.plano, 'procedimentosFeridas', allProcedimentos)
            } else {
                this.$set(this.data.soap, 'procedimentosFeridas', allProcedimentos)
            }
            this.$set(this.data.soap, 'procedimentosVisualizacao', localProcedimentos)

        },
        async store() {

            const isCreation = !this.model.id
            const valid = await this.$refs.RkmForm.validate()

            if (!valid) {
                return
            }

            const tipo = this.data.form.tipos.find(l => l.id === this.model.tipoId)
            const localAnatomico = this.data.form.locaisAnatomico.find(l => l.id === this.model.localAnatomicoId)
            const localAnatomicoRegiao = this.data.form.locaisAnatomicoRegiao.find(l => l.id === this.model.localAnatomicoRegiaoId)
            const exsudato = this.data.form.exsudatos.find(l => l.id === this.model.exsudatoId)
            const necrose = this.data.form.necroses.find(l => l.id === this.model.necroseId)

            if (!this.model.id) {
                this.model.id = this.uniqueId('ferida' + new Date().getTime())
            }

            const params = {
                id: this.model.id,
                data: this.others.moment(this.model.data).format('DD/MM/YYYY'),
                tipoId: this.model.tipoId,
                tipoDescricao: tipo.nome,
                localAnatomicoId: localAnatomico.id,
                localAnatomicoDescricao: localAnatomico.descricao,
                 localAnatomicoRegiaoDescricao: localAnatomicoRegiao.descricao,
                localAnatomicoRegiaoId: localAnatomicoRegiao.id,
                exsudatoId: exsudato.id,
                exsudatoDescricao: exsudato.descricao,
                necroseId: necrose.id,
                necroseDescricao: necrose.descricao,
                cicatrizada: this.model.cicatrizada,
                comprimento: this.model.comprimento,
                largura: this.model.largura,
                profundidade: this.model.profundidade,
                dor: this.model.dor,
                image: this.model.image,
                procedimentos: this.model.procedimentos,
                images: this.model.images || [],
            }

            const unsavedProcedimentos = this.model.procedimentos.filter(p => !p.id)

            if (this.data.soap && this.data.soap.id && unsavedProcedimentos.length > 0) {

                this.setLoading()

                try {
                    for (const proc of unsavedProcedimentos) {
                        const payload = {
                            soap_id: this.data.soap.id,
                            ferida: {
                                ...params,
                                id: this.model.id
                            },
                            procedimento: proc
                        }

                        const response = await this.repositories.atendimentoEnfermagem.storeFeridaProcedimento(payload)

                        if (!this.model.id && response.data.ferida_id) {
                            this.model.id = response.data.ferida_id
                            params.id = response.data.ferida_id
                        }

                        if (response.data.procedimento && response.data.procedimento.id) {
                            this.$set(proc, 'id', response.data.procedimento.id)
                            this.$set(proc, 'automatico', false)
                        }
                    }

                    this.updateParentList(params)
                    this.showSuccessNotification('Ferida e procedimentos salvos com sucesso.')
                    this.resetForm()

                    if (!isCreation) {
                        this.$refs.RkmModal.hide()
                    }
                } catch (e) {
                    this.handleError(e)
                } finally {
                    this.unsetLoading()
                }
            } else {
                this.updateParentList(params)
                this.resetForm()

                if (!isCreation) {
                    this.$refs.RkmModal.hide()
                }
            }
        },
        updateParentList(params) {

            if (this.model.id) {
                const objIndex = this.data.model.feridas.findIndex((obj => obj.id == this.model.id))

                if (objIndex !== -1) {
                    this.$set(this.data.model.feridas, objIndex, this.clone(params))
                } else {
                    this.data.model.feridas.push(params)
                }
            } else {
                this.data.model.feridas.push(params)
            }

            this.syncProcedimentosFeridas()
        },
        destroy(item) {
            this.showDeleteConfirmation('Deseja realmente excluir a antropometria?', async () => {

                this.data.model.feridas.splice(this.data.model.feridas.indexOf(item), 1)
                this.syncProcedimentosFeridas()

                this.resetForm()
            })
        },
        destroyImage(item) {

            const destroy = () => this.repositories.atendimento.destroy(item.id)
                .then(() => {

                    const objId = this.model.images.findIndex((obj => obj.id == item.id));

                    this.model.images.splice(objId, 1)
                })

            this.showDeleteConfirmation('Deseja realmente excluir a imagem permanetemente?', destroy, this.handleError)

        },
        visualizar(item, isVisualizar = false) {

            this.resetForm()
            this.isPopulating = true
            this.visualizarModo = isVisualizar
            this.model.id = item.id
            this.model.data = item.data ? this.others.moment(item.data, 'DD/MM/YYYY').toDate() : null,
            this.model.tipoId = item.tipoId
            this.model.localAnatomicoId = item.localAnatomicoId
            this.model.localAnatomicoRegiaoId = item.localAnatomicoRegiaoId
            this.model.exsudatoId = item.exsudatoId 
            this.model.necroseId = item.necroseId
            this.model.cicatrizada = item.cicatrizada
            this.model.comprimento = this.normalizeDecimalValue(item.comprimento)
            this.model.largura = this.normalizeDecimalValue(item.largura)
            this.model.profundidade = this.normalizeDecimalValue(item.profundidade)
            this.model.dor = item.dor
            this.model.image = item.image
            this.model.procedimentos = (item.procedimentos || []).map(p => ({
                ...p,
                cid: p.cid ? p.cid : (p.cid_id ? { id: p.cid_id, codigo: p.cid && p.cid.codigo, nome: p.cid && p.cid.nome } : null),
                quantidade: p.quantidade != null ? p.quantidade : null
            }))
            this.model.images = item.images || []

            this.$nextTick(() => this.isPopulating = false)

            if (this.model.procedimentos.length > 0 && item.soapId == this.data.additionals.soapIdRef) {
                this.setLoading()
                this.validarProcedimentosCboFerida(this.model.procedimentos, false)
                    .catch(this.handleError)
                    .finally(this.unsetLoading)
            }
        },
        edit(item) {

            this.visualizarModo = false
            this.isPopulating = true

            this.model.id = item.id
            this.model.data = item.data ? this.others.moment(item.data, 'DD/MM/YYYY').toDate() : null,
            this.model.tipoId = item.tipoId
            this.model.localAnatomicoId = item.localAnatomicoId
            this.model.localAnatomicoRegiaoId = item.localAnatomicoRegiaoId
            this.model.exsudatoId = item.exsudatoId
            this.model.necroseId = item.necroseId
            this.model.cicatrizada = item.cicatrizada
            this.model.comprimento = this.normalizeDecimalValue(item.comprimento)
            this.model.largura = this.normalizeDecimalValue(item.largura)
            this.model.profundidade = this.normalizeDecimalValue(item.profundidade)
            this.model.dor = item.dor
            this.model.image = item.image
            this.model.procedimentos = item.procedimentos || []
            this.model.images = item.images || []

            this.$nextTick(() => this.isPopulating = false)
        },
        resetForm() {

            this.visualizarModo = false

            this.model.id = null
            this.model.data = null
            this.model.tipoId = null
            this.model.localAnatomicoId = null
            this.model.localAnatomicoDescricao = null
            this.model.localAnatomicoRegiaoId = null
            this.model.locaLAnatomicoRegiaoDescricao = null
            this.model.exsudatoId = null
            this.model.exsudatoDescricao = null
            this.model.necroseId = null
            this.model.necroseDescricao = null
            this.model.cicatrizada = false
            this.model.comprimento = null
            this.model.largura = null
            this.model.profundidade = null
            this.model.dor = null
            this.model.procedimentos = []
            this.model.image = null
            this.model.images = []

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
        validarAnexos(event) {

            const files = event.target.files || [];
            const allowedExtensions = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
            const maxFileSize = 2 * 1024 * 1024;


            if (files.length > 10) {
                this.showValidationNotification('Limite de 10 imagens por ferida.');
                this.resetFileInput(event);
                return;
            }

            for (let file of files) {

                if (!allowedExtensions.includes(file.type)) {
                    this.showValidationNotification('Todos os arquivos devem estar no formato PNG/JPG/JPEG/PDF.');
                    this.resetFileInput(event);
                    return;
                }

                if (file.size > maxFileSize) {
                    this.showValidationNotification('Todos os arquivos devem ter no máximo 2MB.');
                    this.resetFileInput(event);
                    return;
                }
            }

            this.model.image = Array.from(files);
        },
        resetFileInput(event) {

            this.model.image = null;

            if (this.$refs.fileInput && typeof this.$refs.fileInput.reset === 'function') {
                this.$refs.fileInput.reset();
            } else {
                event.target.value = '';
            }
        },
        validarProcedimentosCboFerida(procedimentos, excluirIncompativeis = false) {
            const ids = procedimentos.map(p => (p.procedimento && p.procedimento.id) || p.id)
                .filter(id => id != null)

            if (ids.length === 0) {
                return Promise.resolve([])
            }

            return this.repositories.atendimento.validarProcedimentosCbo({ procedimento_ids: ids })
                .then(validResponse => {
                    const idsValidos = validResponse.data
                    const procedimentosFiltrados = procedimentos.filter(p => {
                        const id = (p.procedimento && p.procedimento.id) || p.id
                        return idsValidos.includes(id)
                    })
                    const procedimentosIncompativeis = procedimentos.filter(p => {
                        const id = (p.procedimento && p.procedimento.id) || p.id
                        return !idsValidos.includes(id)
                    })

                    if (procedimentosIncompativeis.length > 0) {
                        const nomes = procedimentosIncompativeis.map(p => {
                            const codigo = p.codigo || (p.procedimento && p.procedimento.codigo)
                            const nome = p.nome || (p.procedimento && p.procedimento.nome)
                            return `<b>${codigo} - ${nome}</b>`
                        }).join('<br>')

                        if (excluirIncompativeis) {
                            this.showWarningNotification(`Os seguintes procedimentos foram excluídos por não serem compatíveis com o CBO do profissional:<br>${nomes}`)
                        } else {
                            this.showWarningNotification(`Os seguintes procedimentos não são compatíveis com o CBO do profissional:<br>${nomes}`)
                        }
                    }

                    return excluirIncompativeis ? procedimentosFiltrados : procedimentos
                })
        },
    },
    mixins: [error, object, repository, stringCase],
    props: {
        data: {required: true, type: Object},
        readonly: {type: Boolean, default: false}
    },
}
</script>

<style scoped>
.infor {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    position: absolute;
    right: 8px;
    top: 5px;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
}
</style>